import mrpStyles from './../mrp.json'

export default {
  border: '0',
  nameColor: mrpStyles.colors.PrimaryBlack,
  descriptionColor: mrpStyles.colors.SecondaryGreySky,
  priceColor: mrpStyles.colors.PrimaryBlack,
  salePriceColor: mrpStyles.colors.SecondaryRed,
  badge: {
    type: 'Heading',
    name: 'A3',
    color: mrpStyles.colors.SecondaryGreySky
  }
}
